// extracted by mini-css-extract-plugin
export var externalLink = "_dn-0";
export var internalLinkLabel = "_dn-1";